<template>
    <div>
        <el-card>
            <div slot="header" class="clearfix" style="text-align:center;">
                <a style="text-decoration:none;color:#337ab7;cursor:pointer; float: left; line-height: 36px;" @click="returnBack">返回</a>
        
                <span style="line-height: 36px;" >编辑分销商城信息</span>
            </div>
            <div class="card-body" style="text-align:left;">
                <div class="item-list">

                  <p>
                      <span class="span_1" >首页公告：</span>
                      <el-input v-model="fxShopInfo.notice" style="width:200px;" type="textarea"></el-input>
                  </p>
                  



                  <p>
                      <span class="span_1">客服二维码：</span>
                      <el-upload
                          ref="upload"
                          class="upload-demo"
                          action="http://upload.qiniu.com/"
                          :data="myForm"
                          method="post"
                          :on-preview="handlePreview"
                          :show-file-list="false"
                          :before-upload="handleBeforeUpload"
                          :on-success="handleSuccess"
                          :multiple="isMultiple"
                          :file-list="fileList1">
                          <el-button size="small" type="primary" @click="ctrlType(0)">选择文件</el-button>
                      </el-upload>
                      <br>
                      <img :src="fxShopInfo.customQrcode" style="width:200px;margin-left:250px;">
                  </p>

                
                  <p>
                      <span class="span_1">公司介绍：</span>
                      <!--<el-input v-model="commodity.commodityDesc" style="width:200px;"></el-input>-->
                      <UEditor :config=config ref="ueditor"></UEditor>
                  </p>

                </div>


                <div style="text-align: center">
                    <el-button class="item-right" type="info" :loading="btnLogin" @click="btnSave()">保存</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>
<script>
  import $ajax from '../../https/config'

  import {getQueryString, isNull} from '../../js/tool'

  import UEditor from '@/components/ueditor/ueditor.vue'

  export default {
    data () {
      return {
        fxShopInfo:{
          id:0,
          notice: '',
          companyInfo: '',
          customQrcode: ''
        },
        btnLogin:false,
        editFlag:0,
        bOnSale:true,
        isMultiple: true,
        fileList1: [],
        fileList2: [],
        img1: '',
        img2: '',
        form: {},
        commodityGallerys:[],
        config: {
            //可以在此处定义工具栏的内容
            // toolbars: [
            //  ['fullscreen', 'undo', 'redo','|','bold', 'italic', 'underline',
            //  '|','superscript','subscript','|', 'insertorderedlist', 'insertunorderedlist',
            //  '|','fontfamily','fontsize','justifyleft','justifyright','justifycenter','justifyjustify']
            // ],
            autoHeightEnabled: false,
            autoFloatEnabled: true,
            initialContent:'',   //初始化编辑器的内容,也可以通过textarea/script给值，看官网例子
            autoClearinitialContent:true, //是否自动清除编辑器初始内容，注意：如果focus属性设置为true,这个也为真，那么编辑器一上来就会触发导致初始化的内容看不到了
            initialFrameWidth: null,
            initialFrameHeight: 450,
            BaseUrl: '',
            UEDITOR_HOME_URL: 'static/ueditor/'
          },
          addFormVisible: false
      }
    },
    computed: {
      myForm: {
        set: function (value) {
          this.form = value
        },
        get: function () {
          return this.form
        }
      }
    },
    created: function () {
      this.getCommodityDetail()
      this.getUpToken ()

    },
    methods: {
      getCommodityDetail: function () {
     

        var _this = this

        _this.editFlag = 1;
        var userInfoStr = sessionStorage.getItem('lbz-device-user-info')
        var userInfo =  JSON.parse(userInfoStr)
        var url = '/fx/app/fxShopInfo'
        var params = {
          owner :userInfo.owner
        }

        $ajax.get(url, params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            if (res.resultData!=null){
              _this.fxShopInfo = res.resultData;
             _this.$refs.ueditor.setReadyFunc(function() {
              //console.log("ueditorueditorueditorueditorueditor")
                _this.$refs.ueditor.setContent(_this.fxShopInfo.companyInfo) //赋值给UEditor
            })
            }
            
          }
        }, function () {})
      },
      getUpToken () {
        var myUrl =  'http://platform.songzb.com:32000/qiniuToken/image'
        var _this = this
        $ajax.get(myUrl, '', '', function (res) {
          _this.form.token = res.uptoken
        }, function () {
        })
      },
      handlePreview (file) {
      },
      handleBeforeUpload (file) {
        var last
        last = file.name.split('.').pop()
        if (last !== 'jpg' && last !== 'png' && last !== 'jpeg') {
          this.$message({
            type: 'error',
            message: '图片格式错误'
          })
          return false
        }
        var str = 'spgallery-' + (new Date().getTime()) + Math.ceil(Math.random() * 10) + '.' + last
        this.form.key = str
      },
      handleSuccess (response, file, fileList) {
        if (this.myType === 0) {
          //this.img1 = 'http://res.songzb.com/' + response.key
          this.fxShopInfo.customQrcode = 'http://image.songzb.com/' + response.key
        } else {
          //this.img2 = 'http://image.songzb.com/' + response.key
          //this.commodityGallerys.push('http://image.songzb.com/' + response.key);
        }
      },
      ctrlType (type) {
        if (type === 0) {
          this.myType = 0
        } else {
          this.myType = 1
        }
      },
      delImage (key){
        var _this = this;
        var tCommodityGallerys = [];
        for (var i=0; i<_this.commodityGallerys.length; i++){
          //console.log(_this.commodityGallerys[i]);
          if (key==i){

          }else{
            if (!isNull(_this.commodityGallerys[i])){
              tCommodityGallerys.push(_this.commodityGallerys[i]);
            }
          }
        }
        _this.commodityGallerys = tCommodityGallerys;
      },
      btnSave: function () {
        var _this = this
        var url = '/fx/updatefxShopInfo'

      
        var params = _this.fxShopInfo

        let content = this.$refs.ueditor.getContent()
        console.log(content);
        _this.fxShopInfo.companyInfo = content

        $ajax.post(url, params, 'headers', function (res) {
          if (res && res.resultStatus === true) {
            _this.$message({
              type: 'success',
              message: '保存信息成功!'
            })
            setTimeout(function () {
              _this.btnLogin = false
        
            }, 1000)
          } else {
            _this.$message({
              type: 'error',
              message: '保存信息失败!' + res.errorMessage
            })
            _this.btnLogin = false
          }
        })
      },
      returnBack () {
        this.$router.back(-1)
      }
    },
    components: {
      UEditor
    }
  }
</script>
<style lang="scss">
    .card-body .item-list:nth-child(n+2) {
        margin-top: 20px;
    }
    .upload-demo {

        margin-bottom:  10px;
        display: inline-block;
    }
    .span_1{
            display: inline-block;
            width: 250px;

          }

    .item-list {
        display: inline-block;
        width: 100%;

        .item-left, .item-right {
            float: left;
            text-align: left;

        }

        .item-left {
             margin-right: 30px;
            span {
                vertical-align:sub;
                vertical-align:-webkit-baseline-middle;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/fxshop/fxShopInfo.vue